<template>
  <div class="md-layout md-gutter moreInfoGroup">
    <div class="md-layout-item md-size-33">
      <md-field>
        <select v-model="$store.state.plot.localization.exposition" name="exposition">
          <option disabled value="">{{ $t("localization.exposition") }}</option>
          <option v-for="(exp, key) in expositionList" :value="key" :key="key">{{ exp }}</option>
        </select>
      </md-field>
    </div>
    <div class="md-layout-item md-size-33">
      <md-field>
        <select v-model="$store.state.plot.localization.relief" name="relief">
          <option disabled value="">{{ $t("localization.relief") }}</option>
          <option v-for="(rel, key) in reliefList" :value="key" :key="key">{{ rel }}</option>
        </select>
      </md-field>
    </div>
    <div class="md-layout-item md-size-33">
      <md-field>
        <select v-model="$store.state.plot.localization.rock_formation" name="rockFormation">
          <option disabled value="">{{ $t("localization.rockFormation") }}</option>
          <option v-for="(rf, key) in rockFormationList" :value="key" :key="key">{{ rf }}</option>
        </select>
      </md-field>
    </div>

    <div class="md-layout-item md-size-33">
      <md-field>
        <select v-model="$store.state.plot.localization.litter_depth" name="litterDepth">
          <option disabled value="">{{ $t("localization.litterDepth") }} (cm)</option>
          <option v-for="(ld, key) in litterDepthList" :value="key" :key="key">{{ ld }}</option>
        </select>
      </md-field>
    </div>
    <div class="md-layout-item md-size-33">
      <md-field>
        <select v-model="$store.state.plot.localization.humus_depth" name="humusDepth">
          <option disabled value="">{{ $t("localization.humusDepth") }} (cm)</option>
          <option v-for="(hd, key) in humusDepthList" :value="key" :key="key">{{ hd }}</option>
        </select>
      </md-field>
    </div>
    <div class="md-layout-item md-size-33">
      <md-field>
        <select v-model="$store.state.plot.localization.land_cover" name="landCover">
          <option disabled value="">{{ $t("localization.landCover") }}</option>
          <option v-for="(lc, key) in landCoverList" :value="key" :key="key">{{ lc }}</option>
        </select>
      </md-field>
    </div>
  </div>
</template>

<script>
import { getDomain } from '@/assets/scripts/domainsManager'

const EXPOSITION = 'exposition'
const RELIEF = 'relief'
const ROCK_FORMATION = 'rock_formation'
const LAND_COVER = 'land_cover'
const LITTER_DEPTH = 'litter_depth'
const HUMUS_DEPTH = 'humus_depth'

export default {
  name: 'SiteDescription',
  data: () => ({
    expositionList: {},
    reliefList: {},
    rockFormationList: {},
    humusDepthList: {},
    litterDepthList: {},
    landCoverList: {}
  }),
  mounted () {
    getDomain(EXPOSITION).then(data => {
      this.expositionList = data[this.$i18n.locale]
    })
    getDomain(RELIEF).then(data => {
      this.reliefList = data[this.$i18n.locale]
    })
    getDomain(ROCK_FORMATION).then(data => {
      this.rockFormationList = data[this.$i18n.locale]
    })
    getDomain(LAND_COVER).then(data => {
      this.landCoverList = data[this.$i18n.locale]
    })
    getDomain(LITTER_DEPTH).then(data => {
      this.litterDepthList = data[this.$i18n.locale]
    })
    getDomain(HUMUS_DEPTH).then(data => {
      this.humusDepthList = data[this.$i18n.locale]
    })
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/style/arcadia_theme.scss';
</style>
